var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// sections/WidgetSection.tsx
import { SettingsSection } from "../../themeSettingsUtils";
import { useThemeConfig } from "../themeConfigContext";
export default function WidgetSection() {
    var _a = useThemeConfig(), configs = _a.configs, updateSetting = _a.updateSetting, handlePaddingMarginChange = _a.handlePaddingMarginChange, units = _a.units;
    return (_jsx("div", __assign({ className: "" }, { children: _jsx("div", __assign({ className: "" }, { children: _jsx("div", __assign({ className: "columns flex flex-wrap gap-4" }, { children: _jsx(SettingsSection, { title: "Widget", label: "Widget", configs: configs, updateSetting: updateSetting, handlePaddingMarginChange: handlePaddingMarginChange, units: units, margin: true, border: true, hasDefault: true, borderDefaultValue: "0px" }) })) })) })));
}
